import { __rest, __assign } from '../../../../../../node_modules/tslib/tslib.es6.js';
import React__default from 'react';
import { Box, Typography } from '@mui/material';
import { BarThumb, StyledLinearProgress } from './styles.js';
import { round } from 'lodash-es';

var ZScoreBar = function (_a) {
    var value = _a.value, _b = _a.max, max = _b === void 0 ? 100 : _b, id = _a.id, props = __rest(_a, ["value", "max", "id"]);
    var pct = Math.min((value / max) * 100, 100);
    return (React__default.createElement(Box, { sx: { display: "flex", alignItems: "center" }, id: id },
        React__default.createElement(Box, { sx: { flex: 1, mr: "13px", position: "relative" } },
            React__default.createElement(BarThumb, { value: pct }),
            React__default.createElement(StyledLinearProgress, __assign({ variant: "determinate", value: pct }, props))),
        React__default.createElement(Box, { sx: { minWidth: 53 }, display: "flex", alignItems: "center", justifyContent: "flex-start" },
            React__default.createElement(Typography, { variant: "body2", color: "neutral000", fontSize: 15, fontWeight: 500 }, "".concat(round(value, 1))),
            React__default.createElement(Typography, { color: "paleBlue", fontSize: 12, fontWeight: 400 }, "/".concat(Math.round(max))))));
};

export { ZScoreBar as default };
